(function(clog){
  document.addEventListener('DOMContentLoaded', (event) => {
    clog('newFunction')
    
  	const addCartBtn    = document.querySelector('button[name="add"]');
    const fromNote      = document.getElementById('fromNote');
    const toNote        = document.getElementById('toNote');
    const msgNote       = document.getElementById('textCustomize');
    const qtyBtn        = document.querySelector('input[name="quantity"]');
    const varSelect     = document.querySelector('select[name="id"]');
	const addToCartAndGoBtn   = document.getElementById('addToCartAndGo');       

    addCartBtn.addEventListener('click', (evt) => {
        if ( isCorrectNote() ) {
            evt.preventDefault()
            evt.stopPropagation()

            newAdd()
        }

    })
    
    addToCartAndGoBtn.addEventListener('click', addItemAndGo)
    
    msgNote.addEventListener('keyup', (evt) => {
      let arrayLength
      let newArray = []
      if ( evt.which === 32 || evt.which === 13 ) {
        arrayLength = evt.target.value.split(' ').length
        newArray = evt.target.value.split(' ').slice(0, arrayLength-1)
        if ( newArray.length < 40 ) {
          console.log(newArray)
        } else {
          evt.target.value = newArray.slice(0, newArray.length - 1 ).join(' ')
          alert('40 palabras permitidas como máximo.')
          return false;
        }
      }

    })

    // Functions
    function isCorrectNote() {
        if ( fromNote.value != '' && toNote.value != '' && msgNote != '' ) {
            return true;
        } else {
        	return false;
        }
    }

    async function newAdd() {
        let currentVarId = varSelect.value

        let itemJson = {
            quantity: qtyBtn.value,
            id: currentVarId,
            properties: {
                [`Msg-From_${fromNote.value}-To_${toNote.value}`]: msgNote.value
            }
        }

        try {
            let postAdditional = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify( itemJson )
            })
            let postResponse = await postAdditional.json()

            clog( postResponse )

            // addCartBtn.removeEventListener('click', btnListener, false)
            $('body').trigger('added.ajaxProduct', this.$addToCart);
            // clog('nowClicking without event')
            // addCartBtn.click();

        } catch (err) {
            console.error(err)
        }
    }
    
    

        async function addItemAndGo() {
          let postParams
          
          if ( isCorrectNote() ) {
            
            let itemJson = {
              quantity: qtyBtn.value,
              id: varSelect.value,
              properties: {
                [`Msg-From_${fromNote.value}-To_${toNote.value}`]: msgNote.value
              }
            }
            
            postParams = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify( itemJson )
            }
          
          } else {
            
          	postParams = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ quantity: qtyBtn.value, id: varSelect.value })
            }
            
          }
          
          try {
            
            let postCartData = await fetch('/cart/add.js', postParams)
            let postCartResponse = await postCartData.json()

            console.log(
              postCartData,
              postCartResponse
            )
            
            if ( postCartData.status >= 200 && postCartData.status < 400 ) {
            	window.location.href = '/cart'
            } else {
            	drawError()
            }
            
          } catch (err) {
            	drawError()
          }
    
        function drawError() {
			document.body.innerHTML('Error while adding to cart due to: ' + err + '\n' + 'Reloading in 5 seconds')

            setTimeout(() => {
                       window.location.reload()
          }, 5000)
        }
      }
    
  })
})(console.log)